import { Link } from "react-router-dom";
import { sortDramas } from "@/lib/data";
import { dramas } from "@/mocks/dramas";
import type { Drama } from "@/types";

const top = sortDramas(dramas as Drama[], "popularity").slice(0, 6);

export default function HotRank() {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <div className="flex items-center gap-3 mb-4">
        <span className="w-1.5 h-6 rounded-full bg-accent-500" />
        <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
          热门剧集榜
        </h2>
        <Link
          to="/list/hot"
          className="ml-auto text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          完整榜单
        </Link>
      </div>
      <ul className="space-y-2">
        {top.map((d, i) => (
          <li key={d.id}>
            <Link
              to={`/detail/${d.id}`}
              className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`w-6 text-center font-heading font-bold text-base ${
                  i < 3 ? "text-accent-500" : "text-foreground-400"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-12 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={d.cover}
                  alt={d.title}
                  title={`${d.title} - 漂亮的保姆`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-medium text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {d.title}
                </p>
                <p className="text-xs text-foreground-400 truncate mt-1">
                  {d.genre} · {d.status}
                </p>
              </div>
              <span className="text-accent-600 text-sm font-semibold shrink-0">
                {d.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}